import {
  IssueFragment,
  ReopenIssueMutation,
  ReopenIssueMutationVariables,
  useReopenIssueMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useReopenIssue = withStandardMutationHook<
  ReopenIssueMutation,
  IssueFragment,
  ReopenIssueMutationVariables,
  'reopenIssue',
  [string]
>(useReopenIssueMutation, 'reopenIssue', name => ({
  name,
}));
